module.exports = __webpack_public_path__ + "static/media/elsa-icon.9db27fbf.png";